import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    setEnableNativeAppConfirmation,
    setNativeConfirmationBacFilter,
    setNoAvailabilityErrorByBac,
} from '../../Redux/ActionCreator';

const LDContextUpdate = () => {
    const ldClient = useLDClient();
    const dispatch = useDispatch();
    const { country, bac } = useSelector((state) => state.prefillReducer);
    const dealerSummaryObject = useSelector((state) => state.prefillReducer.dealerSummaryObject);
    const dmsTradingPartnerId = dealerSummaryObject?.dmsTradingPartnerId ?? '';

    useEffect(() => {
        if (country && bac && ldClient) {
            const newMultiContext = {
                kind: 'multi',
                user: {
                    key: 'app-user-46679',
                    country: country,
                    dmsVendor: dmsTradingPartnerId,
                },
                dealership: {
                    key: 'app-dealership-46679',
                    bac: bac,
                },
            };

            ldClient
                .identify(newMultiContext)
                .then(() => {
                    const enableNativeAppConfirmation = ldClient.variation('enableNativeAppConfirmation', false);
                    dispatch(setEnableNativeAppConfirmation(enableNativeAppConfirmation));

                    const nativeConfirmationBacFilter = ldClient.variation('nativeConfirmationBacFilter', true);
                    dispatch(setNativeConfirmationBacFilter(nativeConfirmationBacFilter));

                    const enableNoAvailabilityErrorByBac = ldClient.variation('enableNoAvailabilityErrorByBac', true);
                    dispatch(setNoAvailabilityErrorByBac(enableNoAvailabilityErrorByBac));
                })
                .catch(() => {
                    // If identify fails, dispatch defaults so flags are always set to a known state
                    dispatch(setEnableNativeAppConfirmation(false));
                    dispatch(setNativeConfirmationBacFilter(true));
                    dispatch(setNoAvailabilityErrorByBac(true));
                });
        }
    }, [country, bac, ldClient, dmsTradingPartnerId, dispatch]);

    return <></>;
};

export default LDContextUpdate;
